import { IsArray, IsBoolean, IsOptional, IsString } from 'class-validator';

export class ProvisionSearchIndexesDto {
	@IsArray()
	@IsString({ each: true })
	public tenantAliases!: Array<string>;

	@IsArray()
	@IsString({ each: true })
	public entityTypes!: Array<'client' | 'item'>;

	@IsOptional()
	@IsBoolean()
	public runBulkIndex?: boolean;
}
